/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

// 资金管理
import ManageIndex from './manage/Index';
import ManageAdd from './manage/PageAdd';
import PoolIndex from './pool/Index';
import MineIndex from './mine/Index';
import ProtectSetIndex from './protectSet/Index';
import ProductIndex from './product/Index';
import ProductAdd from './product/PageAdd';

const router = {
  path: 'client',
  breadcrumbName: '客户管理',
  childRoutes: [
    {
      path: 'manage',
      breadcrumbName: '客户管理',
      indexRoute: { component: ManageIndex },
      childRoutes: [
        {
          path: 'add',
          breadcrumbName: '新建客户',
          indexRoute: { component: ManageAdd },
        },
      ],
    },
    {
      path: 'pool',
      breadcrumbName: '客户共享池管理',
      indexRoute: { component: PoolIndex },
      childRoutes: [
        {
          path: 'add',
          breadcrumbName: '新建客户',
          indexRoute: { component: ManageAdd },
        },
      ],
    },
    {
      path: 'mine',
      breadcrumbName: '我的客户',
      indexRoute: { component: MineIndex },
    },
    {
      path: 'protectSet',
      breadcrumbName: '保护设置',
      indexRoute: { component: ProtectSetIndex },
    },
    {
      path: 'product',
      breadcrumbName: '业务产品管理',
      indexRoute: { component: ProductIndex },
      childRoutes: [
        {
          path: 'add',
          breadcrumbName: '新建业务产品',
          indexRoute: { component: ProductAdd },
        },
      ],
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/client/router.js